import ReactDOM from "react-dom/client";
import "./index.css";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import App from "./App";
import NotFound from "./ui/not-found/NotFound";
import Ramadan from "./ui/ramadan/Ramadan";

const router = createBrowserRouter([
  { path: "*", element: <NotFound /> },
  { path: "/", element: <App /> },
  { path: "/kuala-lumpur", element: <App /> },
  { path: "/selangor", element: <App /> },
  { path: "/putrajaya", element: <App /> },
  { path: "/imsak-berbuka", element: <Ramadan /> },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  /*<React.StrictMode>
    <App />
  </React.StrictMode>*/
  <RouterProvider router={router} />,
);
